import { render, staticRenderFns } from "./Etapa11.vue?vue&type=template&id=576af316&scoped=true"
import script from "./Etapa11.vue?vue&type=script&lang=js"
export * from "./Etapa11.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=576af316&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa11.vue?vue&type=style&index=1&id=576af316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576af316",
  null
  
)

export default component.exports